import { Languages } from '../utils/commonUtil';

// Every list in this app is read by Danish clinic staff, so ordering is always
// Danish: Æ, Ø and Å close the alphabet and å is the last letter, full stop.
//
// This deliberately does NOT follow the interface language or the device
// locale. Both are the wrong axis. A planner who switches the UI to English, or
// who is simply on an English-locale machine, is still reading Danish patient
// names, and under any non-Danish collation the tail of the alphabet scatters
// into the middle of the list: Å and Ø fold into A and O, so "Åse" lands
// between "Anna" and "Bo", while Æ is not folded but misfiled ahead of the
// whole A block, so "Ærø" comes before "Anna". Pinning the collation keeps the
// same name in the same place for everyone, whatever machine they sit at.
export const SORT_LOCALE = Languages.da;
